import { render } from "./InclassEvaluation.vue?vue&type=template&id=41973673"
import script from "./InclassEvaluation.vue?vue&type=script&lang=js"
export * from "./InclassEvaluation.vue?vue&type=script&lang=js"

import "./InclassEvaluation.vue?vue&type=style&index=0&id=41973673&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__